export const getGtmProductItemsData = (productItems, quantity, taxRate, index = null) => {
    return productItems.map((product, productIndex) => {
        return {
            'id': product.id,
            'sku': product.sku,
            'name': product.title,
            'priceWithoutVat': product.presentment_price - product.presentment_price * taxRate,
            'vatAmount': product.presentment_price * taxRate,
            'priceWithTax': product.presentment_price,
            'brand': 'Expedo',
            'categories': product.properties?._analytics_data?.categories ?? [],
            'url': `${window.location.origin}${product.url}`,
            'imageUrl': product.image,
            'availability': product.properties?._analytics_data?.availability ?? '',
            'flags': product.properties?._analytics_data?.flags ?? [],
            'quantity': quantity ?? product?.quantity,
            'listIndex': (index ?? productIndex) + 1,
            'rating': product?.properties?._analytics_data?.rating ?? '',
            'reviews': product?.properties?._analytics_data?.reviews ?? '',
            'productType': product?.properties?._isService ? 'service' : 'product',
        };
    });
};
